import { ChangeDetectorRef, Component, CUSTOM_ELEMENTS_SCHEMA, ElementRef, Inject, NgZone, OnInit, ViewChild } from '@angular/core';
import { GlobalComponent } from 'src/app/global/global.component';
import { ColumnChangeBO, EDI271BO, generate270, GetviewBO, groupList, reutrn270 } from './eligibility270.model';
import { eligibility270Service } from './eligibility270.service';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { SearchSettingsModel, ToolbarItems, FilterSettingsModel, IFilter, GridComponent, PageSettingsModel, DataStateChangeEventArgs, QueryCellInfoEventArgs, TextWrapSettingsModel } from '@syncfusion/ej2-angular-grids';
import { Observable, Subject } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { Get271Fileservice } from './eligibility271.service';
import { columnWidth } from '../icd10/icd10.model';
import { takeUntil } from 'rxjs/operators';
import { CommonApiService } from 'src/app/commonapiservice';
import { Tooltip } from '@syncfusion/ej2-angular-popups';
import {GroupPayorList, GetListBO, getMappedCompanyBO } from '../payer/payer.model';
import { EmployeeService } from '../employee/employee.service';
import { log } from 'console';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';


@Component({
  selector: 'app-eligibility270',
  templateUrl: './eligibility270.component.html',
  styleUrls: ['./eligibility270.component.scss']
})
export class Eligibility270Component implements OnInit {
  private onDestroy$: Subject<void> = new Subject<void>();
  @ViewChild('pdflist') pdflist;
  @ViewChild('pdf271list') pdf271list;
  pdfsrc: any = "";
    private _271ObjectUrl: string | null = null;
  _271id: any = "";
  @ViewChild('gridview270') public gridview270: GridComponent;
  @ViewChild('grid') public gridview271: GridComponent;
  public pageSizes: number[] = [10, 15, 20, 50, 100, 250];
  columnchange: ColumnChangeBO = new ColumnChangeBO();
  ColumnArray_270: ColumnChangeBO[]
  initialPage: PageSettingsModel;
  today: Date = new Date();
  edi271: EDI271BO = new EDI271BO();
  groupList: groupList[];
  payorList: any = [];
  view271client: boolean = false;
  onDOCFileChangedErr: string = ""
  clearingHouseList: any = [];
  filepath: string = "";
  ColumnArrayImportList: any[];
  id: string = "00000000-0000-0000-0000-000000000000";
  companyList: any;
  public formatOptions: object;
  getview270: GetviewBO = new GetviewBO();
  getview271: GetviewBO = new GetviewBO();
  selectedFileName: string = ""
  generate270: generate270 = new generate270;
  created270: reutrn270 = new reutrn270;
  view270: boolean = false;
  viewFiles: boolean = false;
  viewFiles271: boolean = false;
  arraycol: any = [];
  List271Data: any = [];
  public searchSettings: SearchSettingsModel;
  public toolbar: ToolbarItems[];
  filterOptions: FilterSettingsModel;
  filter: IFilter;
  public filterSettings: object;
  public data270: Observable<DataStateChangeEventArgs>;
  public data271: Observable<DataStateChangeEventArgs>;
  @ViewChild('grid') public grid: GridComponent;
  @ViewChild('gridview270') public grid270: GridComponent;
  fileToUpload: any = "";
  ColumnArray: columnWidth[];
  edi271tobedeleted: string = "00000000-0000-0000-0000-000000000000";
  dataviewList270: any = [];
  isinprogressfile:boolean=false;
  public wrapSettings: TextWrapSettingsModel;
  GroupPayorlist: any = [];
  GroupPayorDataList: any = [];
  ListSendBO: GetListBO = new GetListBO();
  public data: Observable<DataStateChangeEventArgs>;
  GroupPayorArray: GroupPayorList[];
  GroupPayor: GroupPayorList = new GroupPayorList();
  SearchText: string = '';
  FilterStatus: any;
   private _271Blob: Blob | null = null;
   safePdfSrc: SafeResourceUrl | null = null;
  constructor(public CommonAPI: CommonApiService, 
    private employeeService: EmployeeService,
    public global: GlobalComponent, 
      private cdr: ChangeDetectorRef,
    public httpService: eligibility270Service, 
     private sanitizer: DomSanitizer,
    @Inject(Get271Fileservice) public gethttp271: Get271Fileservice, 
    public toastrService: ToastrService, 
    public http: HttpClient, ) {
    this.global.agencyList();
    this.data270 = this.httpService;
    this.data271 = this.gethttp271;
    
  }
  ngOnInit(): void {
    if (this.global.globalAgencyId == null || this.global.globalAgencyId == '' || this.global.globalAgencyId == undefined || this.global.globalAgencyId == "00000000-0000-0000-0000-000000000000") {
      return;
    }
    this.wrapSettings = { wrapMode: 'Content' };
    this.getGroupList();
    this.getClearingHouseList();
    this.toolbar = ['ColumnChooser'];
    this.formatOptions = { type: 'date', format: 'MM/dd/yyyy h:mm:ss a' };
    this.filterSettings = {
      type: 'Menu',
    };
    this.initialPage = { currentPage: 1, totalRecordsCount: 0, pageCount: 10, pageSize: this.pageSizes[0], pageSizes: this.pageSizes };
  }
  Refresh() {
    this.getview271.orderColumn = "id";
    this.getview271.field = "fileName";
    this.getview271.currentpageno = 1
    this.getview271.value = "";
    this.getview271.type = "string";
    this.selectedFileName = "";
    this.gridview271.pageSettings.currentPage = 1;
    this.view271filedata();
    this.gridview271.clearFiltering();
    this.gridview271.clearSorting();
  }
  Refresh270() {
    this.getview270.type = "string";
    this.getview270.field = "FileName";
    this.getview270.operator = "startswith";
    this.getview270.value = "";
    this.getview270.orderColumn = "FileName";
    this.getview270.orderType = "asc";
    this.getview270.currentpageno = 1;
    this.gridview270.pageSettings.currentPage = 1;
    this.view270filedata();
    this.gridview270.clearFiltering();
    this.gridview270.clearSorting();
  }
  ////////////////////////////// Show Column Chooser /////////////////////////////////////
  show() {
    this.grid.columnChooserModule.openColumnChooser(200, 50);
  }
  onDOCFileChanged() {
    if(this.isinprogressfile){
      this.toastrService.error("File is InProgress!");
      return;
    }
    this.selectedFileName = this.fileToUpload.name;
    let body = new FormData();
    body.append('Filepath', this.fileToUpload);
    let url = "api/ClaimProcess/Import271?agency=" + this.global.globalAgencyId.toString();
    this.CommonAPI.saveorUpdateFunctionwithResponseTypeText(body,url).pipe(takeUntil(this.onDestroy$)).subscribe(
      (data: any) => {
        this.onDOCFileChangedErr = "";
        this.selectedFileName = '';
        this.toastrService.success(
          "File imported successfully!"
        ), 8000
        this.view271filedata();
        // if (data.length > 0) {
        //   this.onDOCFileChangedErr = "";
        //   this.onDOCFileChangedErr = data[0];
        //   if (this.onDOCFileChangedErr != "") {
        //     this.onDOCFileChangedErr = "Client(s) not Found: " + this.onDOCFileChangedErr;
        //   }
        //   if (this.onDOCFileChangedErr != "") {
        //     setTimeout(function () {
        //       this.onDOCFileChangedErr = "";
        //     }.bind(this), 8000);
        //   }
        // }
      },
      (err: any) => {
  this.selectedFileName = '';
  this.onDOCFileChangedErr = '';

  let errorMessage = 'An error occurred while uploading the file.';

  console.log('Full Error Object:', err);
  console.log('err.error:', err.error);

  try {
    // The error comes as: Message: {"error":"271 file already exists for this agency"}
    if (typeof err === 'string') {
      let errorStr = err;
      
      // Extract JSON from "Message: {...}" pattern
      const jsonMatch = errorStr.match(/Message:\s*(\{.*\})/);
      if (jsonMatch && jsonMatch[1]) {
        try {
          const parsed = JSON.parse(jsonMatch[1]);
          errorMessage = parsed.error || parsed.message || errorMessage;
          console.log('Extracted error from Message prefix:', errorMessage);
        } catch (e) {
          console.log('Could not parse JSON from Message prefix');
          errorMessage = errorStr;
        }
      } else {
        // If no "Message:" prefix, try parsing directly
        try {
          const parsed = JSON.parse(errorStr);
          errorMessage = parsed.error || parsed.message || errorMessage;
        } catch (e) {
          // Use raw string if can't parse
          errorMessage = errorStr;
        }
      }
    } 
    else if (err.error && typeof err.error === 'object') {
      errorMessage = err.error.error || err.error.message || JSON.stringify(err.error);
    }
  } catch (parseError) {
    console.log('Error parsing:', parseError);
  }

  console.log('Final error message to show:', errorMessage);
  
  // Show error in toaster
  this.toastrService.error(errorMessage, 'Upload Error');
  this.onDOCFileChangedErr = errorMessage;

  // Clear error message after 5 seconds
  setTimeout(() => {
    this.onDOCFileChangedErr = '';
  }, 5000);

  // Refresh the file list
  this.view271filedata();
}
    );

  }
  refreshToGetDropDownValues(ListCode: string) {
    let url = "api/LOV/getLovDropDown?"
    let params = new URLSearchParams();
    params.append("ListCode", ListCode);
    this.CommonAPI.RefreshDropDownList(ListCode, params, url, "LovDropDown").then((data: any) => {
      if (ListCode == 'PAYER') {
        this.groupList = data;
        this.groupList.forEach(element => {
          // element.label = element.Value,
          //   element.value = element.Key.toString();
        })
        this.generate270.groupId = this.GroupPayorlist.filter(s => s.lovName == "MA")[0].id;
        if (this.generate270.groupId != '00000000-0000-0000-0000-000000000000') {
          this.getpayorList();
        }
      }
    })
  }
  change_group(event) {
    // this.Filter_Group = event.target.value;
    this.SearchText = event.target.value;
  }
  getGroupList() {
    this.generate270.companyId = '00000000-0000-0000-0000-000000000000';
    this.generate270.payorId = '00000000-0000-0000-0000-000000000000';
    let url = "api/LOV/getLovDropDown?";
    let params = new URLSearchParams();
    params.append("ListCode", "PAYER");
    this.CommonAPI.getDropDownList("PAYER",params, url, "LovDropDown").then((data: any) => {
      this.groupList = data;
      this.groupList.forEach(element => {
        element.id = element.id;
      })
      this.generate270.groupId = this.groupList.filter(s => s.lovName == "MA")[0].id;
      if (this.generate270.groupId != '00000000-0000-0000-0000-000000000000') {
        this.getpayorList();
      }
      
     
    })
  }
  getpayorList() {
    this.generate270.payorId = '00000000-0000-0000-0000-000000000000'
    this.generate270.clearingHouseId = '00000000-0000-0000-0000-000000000000'
    this.generate270.companyId = '00000000-0000-0000-0000-000000000000';
    let param = new URLSearchParams();
    let GroupId: string = (this.generate270.groupId != null && this.generate270.groupId != undefined) ? this.generate270.groupId : "00000000-0000-0000-0000-000000000000"
    param.append("groupId", GroupId.toString());
    let url = "api/Payer/getpayerId?";
    this.CommonAPI.GetFunctionwithResponseTypeJson(param, url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.payorList = data;
      this.payorList.forEach(element => {
        element.label = element.label,
          element.value = element.value;

      })
      let val = this.payorList.filter(s => s.label == "MA");
      this.generate270.payorId = this.payorList != null ? val.length != 0 ? val[0].value : 0 : 0
      if (this.generate270.payorId != '00000000-0000-0000-0000-000000000000') {
        this.getCompanyList();
      }
    })
  }
  getCompanyList() {
    this.generate270.companyId = '00000000-0000-0000-0000-000000000000';
    let myparams = new URLSearchParams();
    if (this.generate270.groupId == null || this.generate270.groupId == undefined || this.generate270.groupId == '00000000-0000-0000-0000-000000000000' ||
      this.generate270.payorId == null || this.generate270.payorId == undefined || this.generate270.payorId == '00000000-0000-0000-0000-000000000000') {
      return;
    }
    myparams.append("GroupId", this.generate270.groupId.toString())
    myparams.append("PayorId", this.generate270.payorId.toString())
    let url = "api/Payer/getGroupCompanyBatch?";
    this.CommonAPI.GetFunctionwithResponseTypeJson(myparams,url).pipe(takeUntil(this.onDestroy$)).subscribe((data: [{ Key: number, Value: string }]) => {
      this.companyList = data;
    })
  }
  getClearingHouseList() {
    let myparams = new URLSearchParams();
    let url = "api/ClearingHouse/getCommonClearingHouselist?";
    this.CommonAPI.GetFunctionwithResponseTypeJson(myparams,url).pipe(takeUntil(this.onDestroy$)).subscribe((data:any) => {
      this.clearingHouseList = data;
      console.log(this.clearingHouseList,"clearinghouse")
      this.clearingHouseList.forEach(element => {
        element.Key = element.Key;
      })
  },)
  }
  generate270file() {
    let myparams = {
      "clearinghouse": (this.generate270.clearingHouseId.toString()),
      "payer": (this.generate270.payorId.toString()),
      "company": (this.generate270.companyId.toString())
    }
    let url = "api/ClaimProcess/Save270";
    this.CommonAPI.saveorUpdateFunctionwithResponseTypeJson(myparams,url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.created270 = data;
      document.getElementById("openModal1").click();
    },
      (err: any) => {
        this.toastrService.error(err, 'Error')
      }
    );
  }
  openfile() {
    this.viewFiles = true;
  }
  openview270(id) {
    let myparams = new URLSearchParams();
    myparams.append("id", id)
    let url = "api/ClaimProcess/Get270Data?";
    this.CommonAPI.GetFunctionwithResponseTypeJson(myparams,url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.created270 = data;
      this.viewFiles = true;
    },
      (err: any) => {
        this.toastrService.error(err)
      }
    );
  }
  openview271(datas) {
    this._271id = datas;
    let myparams = new URLSearchParams();
    myparams.append("id", datas.id.toString())
    let url = "api/ClaimProcess/Get271Details?";
    this.CommonAPI.GetFunctionwithResponseTypeJson(myparams,url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.pdfsrc = data[0];
      this.viewFiles271 = true;
      document.getElementById("openModal3").click();
    },
      (err: any) => {
        this.toastrService.error(err)
      }
    );
  }
 
  view270filedata() {
    this.getview270.agencyID = (this.global.globalAgencyId)
    this.httpService.outputValues(this.getview270);
    let count = 0;
    this.httpService.pipe(takeUntil(this.onDestroy$)).subscribe((datas: any) => {
      this.dataviewList270 = datas.result;
      ++count;
      // if (datas != null && datas != undefined && count == 1) {
      //   this.getColumnwidthforEligibility270();
      // }
      if (datas != null && datas.result.length > 15) {
        this.gridview270.height = '500';
      }
      else {
        this.gridview270.height = 'auto';
      }
    });
  }
  view271filedata() {
    this.gethttp271.outputValues(this.getview271);
    let count = 0;
    this.gethttp271.pipe(takeUntil(this.onDestroy$)).subscribe((datas: any) => {
      this.List271Data = datas.result;
      ++count;
      this.isinprogressfile=datas.result[0]?.importStatus?.toUpperCase()=='INPROGRESS'
      console.log(this.isinprogressfile,"progresss")
      // if (datas != null && datas != undefined && count == 1) {
      //   this.getColumnwidth();
      // }
      if (datas != null && datas.result.length > 15) {
        this.grid.height = '500';
      }
      else {
        this.grid.height = 'auto';
      }
    })
  }
  public onActionCompleteview270(args) {
    if (args.requestType == "columnstate") {
      let hidearr = [];
      let showarr = [];
      this.gridview270.columns.forEach(element => {
        if (element.visible == false && element.headerText != "Actions" && element.headerText != "") {
          hidearr.push(element.headerText);
        }
        if (element.visible == true && element.headerText != "Actions" && element.headerText != "") {
          showarr.push(element.headerText);
        }
      })
      var count = 0;
      var count1 = 0;
      if (args.columns.length > 0) {
        if (this.arraycol.length > 0) {
          this.arraycol[0].BatchDetail.ShowColumns.forEach(old => {
            showarr.forEach(element => {
              if (old == element) {
                count1 = count1 + 1;
              }
            });
          });
          this.arraycol[0].BatchDetail.HideColumns.forEach(old => {
            hidearr.forEach(element => {
              if (old == element) {
                count = count + 1;
              }
            });
          });
          if (this.arraycol[0].BatchDetail.ShowColumns.length != count1 || this.arraycol[0].BatchDetail.HideColumns.length != count) {
            this.arraycol[0].BatchDetail.ShowColumns = showarr;
            this.arraycol[0].BatchDetail.HideColumns = hidearr;
            // this.SaveColumnwidthViewbatch();
          }
        }
      }
    }
    this.getview270.currentpageno = this.gridview270.pagerModule.pagerObj.currentPage;
    this.getview270.pageitem = this.gridview270.pagerModule.pagerObj.pageSize;
    ;
    if (args.name == "actionBegin" && args.requestType == "filterbeforeopen") {
      this.getview270.type = args.columnType
    }
  }
  onActionCompleteview271(args) {
    this.getview271.currentpageno = this.gridview271.pagerModule.pagerObj.currentPage;
    this.getview271.pageitem = this.gridview271.pagerModule.pagerObj.pageSize;
    if (args.name == "actionBegin" && args.requestType == "filterbeforeopen") {
      this.getview271.type = args.columnType
    }
  }
  ////////////////////////////// File uPload /////////////////////////////////////
  onFileChanged(file) {
    this.fileToUpload = file.item(0);
    this.selectedFileName = file.item(0).name;
  }
  download270(data) {
    let myparams = new URLSearchParams();
    myparams.append("filepath", data);
    let url = "api/ClaimProcess/download270?";
    this.CommonAPI.GetFunctionwithResponseTypeJson(myparams,url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      window.open(data[0]);
    },
      (err: any) => {
        this.toastrService.error(err)
      }
    );
  }
  kendopdfdownloadList() {
    this.pdflist.A4 = true,
      this.pdflist.portrait = true,
      this.pdflist.keepTogether = ".prevent-split",
      this.pdflist.scale = 0.8,
      this.pdflist.saveAs("270Report" + new Date().toLocaleDateString() + '-' + new Date().toLocaleTimeString());
  }
 async kendopdfdownloadList271() {
  const blob = this.b64toBlob(this.pdfsrc.split(",")[1], "application/pdf");
    const blobUrl = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = blobUrl;
    a.download = this._271id.fileName.split(".")[0] + ".pdf";
    a.click();

 }
  
  public dataStateChange(state): void {
    let type = (state.action.requestType).toString();
    if (type != "filterchoicerequest") {
      if ((state.sorted || []).length) {
        this.getview271.orderColumn = state.sorted[0].name;
        this.getview271.orderType = state.sorted[0].direction === 'descending' ? 'DESC' : 'ASC';
      }
    }
    if (type == "filtering" && state.action.action != "clearFilter") {
      if (this.getview271.type == "number") {
        this.getview271.value = state.action.currentFilterObject.value.toString();
        this.getview271.field = state.action.currentFilterObject.field;
      }
      if (this.getview271.type == "date") {
        this.getview271.value = this.global.getDateTimeString(state.action.currentFilterObject.value)
        this.getview271.field = state.action.currentFilterObject.field;
      }
      else {
        this.getview271.value = state.action.currentFilterObject.value;
        this.getview271.field = state.action.currentFilterObject.field;
      }
      this.getview271.matchCase = state.action.currentFilterObject.matchCase;
      this.getview271.operator = state.action.currentFilterObject.operator;
    }
    else {
      if (type == "filtering" && state.action.action == "clearFilter") {
        this.getview271.field = "FileName";
        this.getview271.matchCase = false;
        this.getview271.operator = "contains";
        this.getview271.value = "";
        this.getview271.type = "string"
      }
    }
    this.view271filedata();
    if (type == "paging" && state.action.name == "actionBegin") {
      if (this.arraycol.length != 0) {
        if (this.arraycol[0].Import271.Pagesize != state.take) {
          this.arraycol[0].Import271.Pagesize = state.take
          // this.SaveColumnwidth();
        }
      }
    }
  }
  public dataStateChange270(state): void {
    let type = (state.action.requestType).toString();
    if (type != "filterchoicerequest") {
      if ((state.sorted || []).length) {
        this.getview270.orderColumn = state.sorted[0].name;
        this.getview270.orderType = state.sorted[0].direction === 'descending' ? 'DESC' : 'ASC';
      }
    }
    if (type == "filtering" && state.action.action != "clearFilter") {
      if (this.getview270.type == "number") {
        this.getview270.value = state.action.currentFilterObject.value.toString();
        this.getview270.field = state.action.currentFilterObject.field;
      }
      if (this.getview270.type == "date") {
        this.getview270.value = this.global.getDateTimeString(state.action.currentFilterObject.value)
        this.getview270.field = state.action.currentFilterObject.field;
      }
     
      else {
        this.getview270.value = state.action.currentFilterObject.value;
        this.getview270.field = state.action.currentFilterObject.field;
      }
      this.getview270.matchCase = state.action.currentFilterObject.matchCase;
      this.getview270.operator = state.action.currentFilterObject.operator;
    }
    else {
      if (type == "filtering" && state.action.action == "clearFilter") {
        this.getview270.field = "Name";
        this.getview270.matchCase = false;
        this.getview270.operator = "contains";
        this.getview270.value = "";
        this.getview270.type = "string"
      }
    }
    
    this.view270filedata();
    if (type == "paging" && state.action.name == "actionBegin") {
      if (this.arraycol.length != 0) {
        if (this.arraycol[0].Eligibility270.Pagesize != state.take) {
          this.arraycol[0].Eligibility270.Pagesize = state.take
          // this.SaveColumnwidthforEligibility270();
        }
      }
    }
  }
  showColumn() {
    this.gridview270.columnChooserModule.openColumnChooser(200, 50);
  }
  // SaveColumnwidthViewbatch() {
  //   this.arraycol[0].view270.Columns = this.ColumnArray_270;
  //   this.arraycol[0].view270.Pagesize = this.gridview270.pageSettings.pageSize;
  //   this.columnchange.userid = parseInt(this.global.userID);
  //   this.columnchange.column = JSON.stringify(this.arraycol);
  //   this.columnchange.id = this.id
  //   this.global.globalColumn = this.columnchange;
  //   this.arraycol = JSON.parse(this.global.globalColumn.column);
  //   let url = "api/ColumnChange/Savewidth?";
  //   this.CommonAPI.saveorUpdateFunctionwithResponseTypeJson(this.columnchange,url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
  //   });
  // }
  make271false() {
    this.view271client = false;
  }
  ///====================Resize Import271 List===========================////
  onResizeSelected(args) {
    if (this.ColumnArrayImportList != null && this.ColumnArrayImportList != undefined) {
      const column = this.grid.getColumnByField(args.column.field)
      column.width = args.column.width;
      this.ColumnArrayImportList.forEach(element => {
        if (element.column == column.headerText) {
          element.width = (column.width.toString());
        }
      });
      // this.SaveColumnwidth();
    }
  }
  // getColumnwidth() {
  //   this.arraycol = JSON.parse(this.global.globalColumn.column);
  //   this.ColumnArrayImportList = this.arraycol[0].Import271.Columns;
  //   if (this.global.globalColumn.userid != null && this.global.globalColumn.agencyId != null) {
  //     this.id = this.global.globalColumn.id;
  //   }
  //   if (this.grid != undefined) {
  //     this.grid.pageSettings.pageSize = this.arraycol[0].Import271.Pagesize;
  //   }
  //   this.ColumnArrayImportList.forEach(element => {
  //     if (element.column == 'Import Date') {
  //       const column = this.grid?.getColumnByField('createDate');
  //       this.grid?.refreshHeader();
  //     }
  //     if (element.column == 'File Name') {
  //       const column = this.grid?.getColumnByField('fileName');
  //       this.grid?.refreshHeader();
  //     }
  //     if (element.column == 'Import Status') {
  //       const column1 = this.grid?.getColumnByField('importStatus');
  //       column1.headerText = element.column;
  //       column1.width = element.width;
  //       this.grid.refreshHeader();
  //     }
  //     if (element.column == 'Error') {
  //       const column1 = this.grid?.getColumnByField('error');
  //       column1.headerText = element.column;
  //       column1.width = element.width;
  //       this.grid.refreshHeader();
  //     }
  //     if (element.column == 'Action') {
  //       const column2 = this.grid?.getColumnByUid('action');
  //       this.grid?.refreshHeader();
  //     }
  //   });
  // }
  // SaveColumnwidth() {
  //   this.arraycol[0].Import271.Columns = this.ColumnArrayImportList;
  //   this.arraycol[0].Import271.Pagesize = this.grid.pageSettings.pageSize;
  //   this.columnchange.userid = parseInt(this.global.userID);
  //   this.columnchange.column = JSON.stringify(this.arraycol);
  //   this.columnchange.id = this.id;
  //   this.global.globalColumn = this.columnchange;
  //   this.arraycol = JSON.parse(this.global.globalColumn.column);
  //   let url = "api/ColumnChange/Savewidth?";
  //   this.CommonAPI.saveorUpdateFunctionwithResponseTypeJson(this.columnchange,url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
  //     this.getColumnwidth();
  //   });
  // }
  // getColumnwidthforEligibility270() {
  //   this.arraycol = JSON.parse(this.global.globalColumn.column);
  //   this.ColumnArray = this.arraycol[0].Eligibility270.Columns;
  //   let showcol = this.arraycol[0].Eligibility270.ShowColumns;
  //   let hidecol = this.arraycol[0].Eligibility270.HideColumns
  //   if (this.global.globalColumn.userid != null && this.global.globalColumn.agencyId != null) {
  //     this.id = this.global.globalColumn.id;
  //   }
  //   this.gridview270.pageSettings.pageSize = this.arraycol[0].Eligibility270.Pagesize;
  //   this.ColumnArray.forEach(element => {
  //     if (element.column == 'Company') {
  //       const column = this.gridview270.getColumnByField('companyName');
  //       column.width = element.width;
  //       this.gridview270.refreshHeader();
  //     }
  //     if (element.column == 'Clearing House') {
  //       const column1 = this.gridview270.getColumnByField('clearingHouseName');
  //       column1.width = element.width;
  //       this.gridview270.refreshHeader();
  //     }
  //     if (element.column == 'File Name') {
  //       const column1 = this.gridview270.getColumnByField('fileName');
  //       column1.width = element.width;
  //       this.gridview270.refreshHeader();
  //     }
  //     if (element.column == 'Generated Date') {
  //       const column1 = this.gridview270.getColumnByField('createDate');
  //       column1.width = element.width;
  //       this.gridview270.refreshHeader();
  //     }
  //     else if (element.column == 'Action') {
  //       const column2 = this.gridview270.getColumnByUid('action');
  //       column2.width = element.width;
  //       this.gridview270.refreshHeader();
  //     }
  //   });
  // }
  onResizeEligibility270(args) {
    if (this.ColumnArray != null && this.ColumnArray != undefined) {
      const column = this.gridview270.getColumnByField(args.column.field);
      column.width = args.column.width;
      this.ColumnArray.forEach(element => {
        if (element.column == column.headerText) {
          element.width = parseInt(column.width.toString());
        }
      });
      // this.SaveColumnwidthforEligibility270();
    }
  }
  // SaveColumnwidthforEligibility270() {
  //   this.arraycol[0].Eligibility270.Columns = this.ColumnArray;
  //   this.arraycol[0].Eligibility270.Pagesize = this.gridview270.pageSettings.pageSize;
  //   this.columnchange.userid = parseInt(this.global.userID);
  //   this.columnchange.column = JSON.stringify(this.arraycol);
  //   this.columnchange.id = this.id;
  //   this.global.globalColumn = this.columnchange;
  //   this.arraycol = JSON.parse(this.global.globalColumn.column);
  //   let url = "api/ColumnChange/Savewidth?";
  //   this.CommonAPI.saveorUpdateFunctionwithResponseTypeJson(this.columnchange,url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
  //     this.getColumnwidthforEligibility270();
  //   });
  // }
  selectEDI271toDelete(data) {
    this.edi271tobedeleted = data.id;
  }
  showSetting() {
    this.grid.columnChooserModule.openColumnChooser(200, 50);
  }
  deleteEDI271() {
    let url="api/ClaimProcess/DeleteEDI271Import/"
    this.CommonAPI.DeleteFunctionForDeleteHttp(this.edi271tobedeleted,url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      document.getElementById('delete271modalopen').click();
      this.toastrService.success('Deleted successfully!'), 8000;
      this.view271filedata();
    }, (err: any) => {
      if (err) {
        this.toastrService.error(err, 'Error'), 8000;
      }
    }
    );
  }
  tobase64 = value => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(value);
    reader.onload = (e: any) => resolve(e.target.result);
    reader.onerror = error => reject(error);
  });

  b64toBlob = (b64Data, contentType = '', sliceSize = 512) => {
    const byteCharacters = atob(b64Data);
    const byteArrays = [];
    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);
      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }
    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
  }
  public ngOnDestroy(): void {
    this.onDestroy$.next();
  }
  
}
